import React, { FC } from 'react'
import { HeaderMobile } from '../../components/Header/HeaderMobile'
import { Footer, PageMobile, StepLine, TitleMobile } from './StepsPage.styles'

export const StepsPageMobile: FC<{ proxyUrl: string }> = ({ proxyUrl }) => (
  <PageMobile>
    <HeaderMobile />
    <TitleMobile>Become a customer in 4 easy steps</TitleMobile>
    <StepLine>
      <div>1</div>
      <span>Consent and share your personal information (PII)</span>
    </StepLine>

    <StepLine>
      <div>2</div>
      <span>Review the document</span>
    </StepLine>

    <StepLine>
      <div>3</div>
      <span>Complete the signing process with identification</span>
    </StepLine>

    <StepLine>
      <div>4</div>
      <span>Micropayment transfer of 0,01€</span>
    </StepLine>

    <Footer>
      <a href={proxyUrl}>Continue</a>
    </Footer>
  </PageMobile>
)
